<template>
  <div v-if="show" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-6 max-w-md w-full mx-4">
      <h2 class="text-xl font-semibold mb-4">Vyberte formát exportu</h2>
      
      <div class="space-y-4">
        <button
          @click="$emit('select', 'plain')"
          class="w-full p-4 border rounded-lg hover:bg-gray-50 transition-colors flex items-center gap-3"
        >
          <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          <div class="text-left">
            <div class="font-medium">Prostý text</div>
            <div class="text-sm text-gray-500">Čistý text bez formátování</div>
          </div>
        </button>

        <button
          @click="$emit('select', 'html')"
          class="w-full p-4 border rounded-lg hover:bg-gray-50 transition-colors flex items-center gap-3"
        >
          <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
          </svg>
          <div class="text-left">
            <div class="font-medium">HTML formát</div>
            <div class="text-sm text-gray-500">Zachová formátování a styly</div>
          </div>
        </button>
      </div>

      <button
        @click="$emit('close')"
        class="mt-6 w-full py-2 px-4 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
      >
        Zrušit
      </button>
    </div>
  </div>
</template>

<script setup>
defineProps({
  show: Boolean
});

defineEmits(['select', 'close']);
</script>